<template>
  <div>
    <hr class="separator-slim mx-6" v-if="allFacilities.length" />
    <div class="search-filter-box p-6" v-if="allFacilities.length">
      <h4 class="fs-20 font-medium mb-4">Amenities</h4>

      <template v-if="resortFacilities.length">
        <h5 class="mt-6 mb-4 font-medium">
          {{ searchType === "resort" ? "Resort" : "Vessel" }}
        </h5>

        <checkbox
          v-for="item in displayingResortFacilities"
          :key="item.slug"
          v-model="options[`opt${item.slug}`]"
          @change="handleOptionsChanged"
        >
          {{ item.name }}
        </checkbox>

        <button
          type="button"
          class="font-medium text-secondary mt-4"
          @click="$refs.resortFacilitiesModal.show()"
        >
          <div>View all {{ resortFacilities.length }} amenities</div>
        </button>
      </template>

      <template v-if="diveCenterFacilities.length">
        <hr class="separator-slim my-6" />

        <h5 class="mt-6 mb-4 font-medium">Diving</h5>

        <checkbox
          v-for="item in displayingDiveCenterFacilities"
          :key="item.slug"
          v-model="options[`opt${item.slug}`]"
          @change="handleOptionsChanged"
        >
          {{ item.name }}
        </checkbox>

        <button
          type="button"
          class="font-medium text-secondary mt-4"
          @click="$refs.diveCenterFacilitiesModal.show()"
        >
          <div>View all {{ diveCenterFacilities.length }} amenities</div>
        </button>
      </template>

      <zb-modal ref="resortFacilitiesModal" class="slide-in-modal">
        <template v-slot:default>
          <div>
            <checkbox
              v-for="item in resortFacilities"
              :key="item.slug"
              v-model="options[`opt${item.slug}`]"
            >
              {{ item.name }}
            </checkbox>
          </div>
        </template>

        <template v-slot:footer>
          <div class="text-right mt-6">
            <hr class="border-black-30 mb-6" />
            <button
              type="button"
              class="btn btn-secondary"
              @click="handleSubmitSearch($refs.resortFacilitiesModal)"
            >
              Search
            </button>
          </div>
        </template>
      </zb-modal>

      <zb-modal ref="diveCenterFacilitiesModal" class="slide-in-modal">
        <template v-slot:default>
          <div>
            <checkbox
              v-for="item in diveCenterFacilities"
              :key="item.slug"
              v-model="options[`opt${item.slug}`]"
            >
              {{ item.name }}
            </checkbox>
          </div>
        </template>

        <template v-slot:footer>
          <div class="text-right mt-6">
            <hr class="border-black-30 mb-6" />
            <button
              type="button"
              class="btn btn-secondary"
              @click="handleSubmitSearch($refs.diveCenterFacilitiesModal)"
            >
              Search
            </button>
          </div>
        </template>
      </zb-modal>
    </div>
  </div>
</template>

<script>
import flatMap from "lodash/flatMap";
import uniqBy from "lodash/uniqBy";
import orderBy from "lodash/orderBy";
import get from "lodash/get";
import { mapState } from "vuex";

import {
  RESORT_FACILITIES,
  LIVEABOARD_FACILITIES,
  DIVE_CENTER_FACILITIES,
} from "../../../helpers/constants";
import Checkbox from "../../../components/core/Checkbox";
import ClearFiltersMixin from "../../../mixins/ClearFiltersMixin";
import ZbModal from "../../core/ZbModal";

export default {
  mixins: [ClearFiltersMixin],
  components: {
    Checkbox,
    ZbModal,
  },
  data() {
    return {
      options: {},
      searchType: window.zubluSearchType,
    };
  },
  computed: {
    ...mapState(["resortsResult"]),
    allFacilities() {
      let allFacilities = flatMap(this.resortsResult, (resort) => {
        return get(resort, ["inclusions_objects"], []);
      });
      allFacilities = uniqBy(allFacilities, (item) => item.name);

      return orderBy(allFacilities, ["order", "name"], ["asc", "asc"]);
    },
    resortFacilities() {
      if (this.searchType === "resort") {
        return this.allFacilities.filter(
          (item) => item.list_id === RESORT_FACILITIES
        );
      } else if (this.searchType === "liveaboard") {
        return this.allFacilities.filter(
          (item) => item.list_id === LIVEABOARD_FACILITIES
        );
      }

      return [];
    },
    displayingResortFacilities() {
      return this.resortFacilities.slice(0, 5);
    },
    diveCenterFacilities() {
      return this.allFacilities.filter(
        (item) => item.list_id === DIVE_CENTER_FACILITIES
      );
    },
    displayingDiveCenterFacilities() {
      return this.diveCenterFacilities.slice(0, 5);
    },
  },
  methods: {
    handleOptionsChanged() {
      let result = [];

      for (const opt in this.options) {
        if (this.options[opt]) {
          result.push(opt.substring(3));
        }
      }

      this.$store.commit("setFilter", {
        name: "facilities",
        value: result.join(","),
      });
    },
    handleSubmitSearch(modal) {
      modal.hide();
      this.handleOptionsChanged();
    },
    loadOptions() {
      const { filters } = this.$store.state;
      const selectingFacilities = filters.facilities.split(",");

      const options = this.allFacilities
        .map((item) => item.slug)
        .reduce((obj, slug) => {
          const isSelected = selectingFacilities.includes(slug);

          return Object.assign({ [`opt${slug}`]: isSelected }, obj);
        }, {});

      return options;
    },
  },
  watch: {
    allFacilities() {
      this.options = this.loadOptions();
    },
  },
};
</script>
